import { RadioGroup } from "@headlessui/react";
import { useEffect, useState } from "react";
import { RadioProps } from "./radio.interface";

export function Radio({ onChange, label, options, value }: RadioProps): JSX.Element {
    const [stateValue, setValue] = useState<any>(value ? value : undefined);

    useEffect(() => {
        setValue(value);
    }, [value]);

    return (
        <RadioGroup
            value={stateValue}
            onChange={(data) => {
                onChange(data);
                setValue(data);
            }}
        >
            {label && <RadioGroup.Label>{label}</RadioGroup.Label>}
            {options.map((option) => (
                <RadioGroup.Option value={option.payload} key={option.payload} disabled={option.disabled}>
                    {({ checked }) => (
                        <div className={`flex items-center gap-2 mb-4 cursor-pointer ${option.disabled && "opacity-50 cursor-not-allowed"}`}>
                            <div
                                className={`w-[20px] h-[20px] flex items-center justify-center border-[1.5px] border-secondary-500 rounded-full ${checked && "bg-primary-600 !border-primary-600"}`}
                            >
                                {checked && <div className="w-[10px] h-[10px] rounded-full bg-white" />}
                            </div>
                            <span className="text-secondary-800 text-[14px]">{option.title}</span>
                        </div>
                    )}
                </RadioGroup.Option>
            ))}
        </RadioGroup>
    );
}
